module.exports = __webpack_public_path__ + "curve.c7ff796f9de0dfd00457.png";


//////////////////
// WEBPACK FOOTER
// C:/Users/Home/OneDrive/Documents/hotellife_web/src/assets/images/curve.png
// module id = ../../../../../src/assets/images/curve.png
// module chunks = styles